import './index.css';

interface SummarySectionProps {
  titlesCount?: number;
  shipmentsCount?: number;
}

const SummarySection = (props: SummarySectionProps) => {
  const {titlesCount = 0, shipmentsCount = 0} = props;

  const data = [
    {
      icon: 'fa-regular fa-book',
      value: `${titlesCount} Titles`,
    },
    {
      icon: 'fa-regular fa-cart-shopping-fast',
      value: `${shipmentsCount} Shipments`,
    },
  ];

  return (
    <div className="SummarySection">
      <span>Summary:</span>
      {data.map((item, index) => (
        <div key={index} className="SummarySection__item">
          <i className={item.icon} />
          <span className="SummarySection__item-value">{item.value}</span>
        </div>
      ))}
    </div>
  );
};

export default SummarySection;
